import React, { useEffect, useState } from "react";
import DragAndDrop from "./DragAndDrop";
import { RotatingSquare } from "react-loader-spinner";

const GoldMiningDragAndDrop = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`https://api.velormall.com/api/admin/mining/gold/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setLoading(false);
      });
  }, []);

  const [FilterData, setFilterData] = useState([]);

  const [FilterDataLoading, setFilterDataLoading] = useState(true);
  useEffect(() => {
    fetch(`https://api.velormall.com/api/admin/mining/gold/filter/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setFilterData(data.data);
        setFilterDataLoading(false);
        
      });
  }, []);

  const MiningData = data.filter((el) => {
    const filter = FilterData.map((x) => x.mining_id).includes(el._id);
    if (!filter) {
      return true;
    }
  });



let MiningFilterData = [];
for (let item of FilterData) {
    for (let filterItem of data) {
        if (item.mining_id === filterItem._id) {
            MiningFilterData.push(filterItem);
            break;
        }

    }
}


  if (loading || FilterDataLoading) {
    return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
  }

  return (
    <>
      <DragAndDrop data={MiningData} FilterData={MiningFilterData} />
    </>
  );
};
export default GoldMiningDragAndDrop;
